import React from 'react';

import { FormTextInput } from 'sellDirect/components/closingDash/form/FormTextInput';
import { IResetableFormRenderProps } from 'sellDirect/components/closingDash/ResetableForm';
import { text } from 'sellDirect/components/closingDash/content';
import { ClosingTasks } from 'sellDirect/helpers/closingTasks';
import { ServiceProvidersFormState } from 'sellDirect/components/closingDash/serviceProviders/ServiceProvidersForm';

interface IProps {
  shouldSeeAgentExperience: boolean;
  closingTasks: ClosingTasks;
  loading?: boolean;
  onCancel?: () => void;
  resetableForm: IResetableFormRenderProps;
}

/**
 * Service providers form - other services section.
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const OtherServicesFormContent: React.FC<IProps> = ({
  shouldSeeAgentExperience,
  resetableForm,
}) => {
  const { onUpdate } = resetableForm;
  const formState: ServiceProvidersFormState = resetableForm.formState;

  return (
    <>
      <FormTextInput
        inputName="trashCollection"
        title={text.disclosuresPage.otherHomeInfo.trashCollectionInfo(shouldSeeAgentExperience)}
        content={formState?.trashCollection}
        onUpdate={onUpdate}
        placeholder={`${
          shouldSeeAgentExperience ? 'Your client’s' : 'Your'
        } garbage collector information`}
      />
      <FormTextInput
        inputName="recyclingCollection"
        title={text.disclosuresPage.otherHomeInfo.recyclingCollectionInfo(shouldSeeAgentExperience)}
        content={formState?.recyclingCollection}
        onUpdate={onUpdate}
        placeholder={`${
          shouldSeeAgentExperience ? 'Your client’s' : 'Your'
        } recycling collector information`}
      />
      <FormTextInput
        inputName="mailboxNumber"
        title={text.disclosuresPage.otherHomeInfo.mailDetails(shouldSeeAgentExperience)}
        content={formState?.mailboxNumber}
        onUpdate={onUpdate}
        placeholder={`${shouldSeeAgentExperience ? 'Your client’s' : 'Your'} mailbox number`}
      />
      <FormTextInput
        inputName="additionalInfo"
        title={text.disclosuresPage.otherHomeInfo.additionalHomeInformation(
          shouldSeeAgentExperience,
        )}
        content={formState?.additionalInfo}
        onUpdate={onUpdate}
        inputType="multiLine"
        placeholder="This can be anything like garage codes, alarm codes, where to find the water shutoff, etc."
      />
    </>
  );
};
